$(document).ready(function() {
    $('.js-client-logos-slider').slick({
        slidesToShow: 6,
        arrows: false,
        centerMode: true,
        autoplay: true, // Enable autoplay
        autoplaySpeed: 1500, // Set autoplay speed in milliseconds
        infinite: true, // Enable infinite looping
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    // Was 1 below 350px (with centerMode: false) - always
                    // show at least 2 logos, even on the narrowest phones.
                    slidesToShow: 2
                }
            }
        ]
    });
});